<template>
<div class="chapter">
<div class="inner_page">
<p class="copy-t"><a id="page_iv"></a><em>Published with the generous support of the Georgia Writers Hall of Fame</em></p>
<p class="copy">Published by the University of Georgia Press<br/>
  Athens, Georgia 30602<br/>
<a href="http://www.ugapress.org" target="_blank">www.ugapress.org</a><br/>
  © 2018 by Nicole Seitz and Jonathan Haupt<br/>
  All rights reserved<br/>
  Designed by Erin Kirk New<br/>
  Set in 10.7 on 15 Minion Pro<br/>
  Printed and bound by Thomson-Shore, Inc.<br/>
  The paper in this book meets the guidelines for permanence and durability of the Committee on Production Guidelines for Book Longevity of the Council on Library Resources.</p>
<p class="copy">Most University of Georgia Press titles are available from popular e-book vendors.</p>
<p class="copy">Printed in the United States of America<br/>
  22  21  20  19  18  c  5  4  3  2  1</p>
<p class="copy">Library of Congress Control Number: 2018018091<br/>
<span class="small">ISBN:</span> 9780820354484 (hardcover: alk. paper)<br/>
<span class="small">ISBN:</span> 9780820354491 (ebook)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copy.vue?045b4e8c